
/*------------------------------------*\
販売サイト(root)
\*------------------------------------*/
$(document).ready(function(){

    var hash = location.hash;
	var headerHeight = $('#global-header-wrapper').height();

	jQuery(window).resize(function(){
		headerHeight = $('#global-header-wrapper').height();
	});

    if(hash) {
        jQuery('body,html').stop().scrollTop(0);

        setTimeout(function(){

            var target = jQuery(hash);
            var position = target.offset().top - headerHeight;

            jQuery("html, body").animate({
                scrollTop: position
            }, 800);

        }, 100);
    }

// 機能一覧のソート
	jQuery(".sort-list > div").click(function(){
		var cat = "." + jQuery(this).attr("class");
		if(cat == ".all"){
			jQuery(".sort-wrapper .sort").show();
		}else{
			jQuery(".sort-wrapper .sort").hide();
			jQuery(cat).show();
		}
	});
	jQuery(".sort-list2 > div").click(function(){
		var cat = "." + jQuery(this).attr("class");
		if(cat == ".all"){
			jQuery(".sort-wrapper .sort2").show();
		}else{
			jQuery(".sort-wrapper .sort2").hide();
			jQuery(cat).show();
		}
	});

	// メニューを最初のコンテンツに到着したら固定  ;ｑｗｓ
	if($('#plan').length){
		$(window).on('load scroll', function () {
			var point = $('main > .container').offset().top;
			var menu = $('.menu-wrapper');
			var scrollposition = $(window).scrollTop();

			if (scrollposition > point) {
				menu.addClass('fixed-top');
				if($("#global-header-wrapper").hasClass('hide')){
					menu.css("top", "0");
				}else{
					menu.css("top", headerHeight);
				}
			} else {
				menu.removeClass('fixed-top');
			}
		});
	}

	if($('#case').length){
		$(window).on('load scroll', function () {
			var point = $('main > .container').offset().top;
			var menu = $('.menu-wrapper');
			var scrollposition = $(window).scrollTop();

			if (scrollposition > point) {
				menu.addClass('fixed-top');
				if($("#global-header-wrapper").hasClass('hide')){
					menu.css("top", "0");
				}else{
					menu.css("top", headerHeight);
				}
			} else {
				menu.removeClass('fixed-top');
			}

			scrollToggleClass("#case-about", ".menu a:nth-child(1)", "active");
			scrollToggleClass("#case-places", ".menu a:nth-child(2)", "active");
			scrollToggleClass("#case-portal", ".menu a:nth-child(3)", "active");
			scrollToggleClass("#case-homepage", ".menu a:nth-child(4)", "active");
			scrollToggleClass("#case-group", ".menu a:nth-child(5)", "active");
			scrollToggleClass("#case-local", ".menu a:nth-child(6)", "active");
			scrollToggleClass("#case-domain", ".menu a:nth-child(7)", "active");
			scrollToggleClass("#case-tenant", ".menu a:nth-child(8)", "active");
		});
	}


	if($('#plan').length){
		$(window).on('load scroll', function () {
			var point = $('main > .container').offset().top;
			var menu = $('.menu-wrapper');
			var scrollposition = $(window).scrollTop();

			if (scrollposition > point) {
				menu.addClass('fixed-top');
				if($("#global-header-wrapper").hasClass('hide')){
					menu.css("top", "0");
				}else{
					menu.css("top", headerHeight);
				}
			} else {
				menu.removeClass('fixed-top');
			}

			scrollToggleClass("#plan-list", ".menu a:nth-child(1)", "active");
			scrollToggleClass("#plan-option", ".menu a:nth-child(2)", "active");
			scrollToggleClass("#plan-recommended", ".menu a:nth-child(3)", "active");
			scrollToggleClass("#ad", ".menu a:nth-child(4)", "active");
			scrollToggleClass("#plan-bill", ".menu a:nth-child(5)", "active");
		});
	}

	if($('#support').length){
		$(window).on('load scroll', function () {
			var point = $('main > .container').offset().top;
			var menu = $('.menu-wrapper');
			var scrollposition = $(window).scrollTop();

			if (scrollposition > point) {
				menu.addClass('fixed-top');
				if($("#global-header-wrapper").hasClass('hide')){
					menu.css("top", "0");
				}else{
					menu.css("top", headerHeight);
				}
			} else {
				menu.removeClass('fixed-top');
			}

			scrollToggleClass("#support-search", ".menu a:nth-child(1)", "active");
			scrollToggleClass("#support-faq", ".menu a:nth-child(2)", "active");
			scrollToggleClass("#support-maintenance", ".menu a:nth-child(3)", "active");
			scrollToggleClass("#support-news", ".menu a:nth-child(4)", "active");
			scrollToggleClass("#support-contact", ".menu a:nth-child(5)", "active");
		});
	}



	function scrollToggleClass(rangeTarget, addTarget, classname) {
		if($(rangeTarget).length){
			scroll = $(window).scrollTop();
			startPos = $(rangeTarget).offset().top - 80;
			endPos = startPos + $(rangeTarget).outerHeight() - 80;

			if (scroll > startPos && scroll < endPos) {
				$(addTarget).addClass(classname);
			} else {
				$(addTarget).removeClass(classname)
			}
		}
	}

    $('.youcanbookme').on('click', function(){
        gtag('event', 'click', {'event_category': 'youcanbookme'});
    });
});
